  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
export const renderCheckbox_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ _jsxs(state.root, {
        children: [
            /*#__PURE__*/ _jsx(state.input, {}),
            state.labelPosition === 'before' && state.label && /*#__PURE__*/ _jsx(state.label, {}),
            /*#__PURE__*/ _jsx(state.indicator, {}),
            state.labelPosition === 'after' && state.label && /*#__PURE__*/ _jsx(state.label, {})
        ]
    });
};
